export const StoreAction = {
    // NOTIFICATION
    NOTIFICATION_DATA: "NOTIFICATION_DATA",
    UPDATE_NOTIFICATION: "UPDATE_NOTIFICATION",
    DELETE_NOTIFICATION: "DELETE_NOTIFICATION",
    ADD_NOTIFICATION: "ADD_NOTIFICATION",

    ADD_EVENT: "ADD_EVENT",
    FETCH_EVENTS: "FETCH_EVENTS",
    UPDATE_EVENT: "UPDATE_EVENT",
    DELETE_EVENT: "DELETE_EVENT",

    FETCH_EVENT_CATEGORY_AND_COLORS: "FETCH_EVENT_CATEGORY_AND_COLORS",
    FETCH_WEATHER_DATA: "FETCH_WEATHER_DATA",

    // AUTH
    FETCH_REGISTRATION_DROPDOWN_DATA: "FETCH_REGISTRATION_DROPDOWN_DATA",
    CLEAR_REDUX: "CLEAR_REDUX",

    // MASTER DATA
    DEPARTMENTS_DATA: "DEPARTMENTS_DATA",
    SECTORS_DATA: "SECTORS_DATA",
    PRIORITIES_DATA: "PRIORITIES_DATA",
    PROJECT_TYPES_DATA: "PROJECT_TYPES_DATA",
    ACTION_PROJECT_TYPES_DATA: "ACTION_PROJECT_TYPES_DATA",
    JURISDICTION_DATA: "JURISDICTION_DATA",
    DISTRICT_DATA: "DISTRICT_DATA",
    MUNICIPALITY_DATA: "MUNICIPALITY_DATA",
    PROGRAMMES_DATA: "PROGRAMMES_DATA",
    IDMS_PROJECT_STAGE_DATA: "IDMS_PROJECT_STAGE_DATA",
    LOCATION_DATA: "LOCATION_DATA",

    // EXECUTIVE SUMMERY DATA
    UPDATE_EXECUTIVE_SUMMERY_DATA: 'UPDATE_EXECUTIVE_SUMMERY_DATA',

    // PROBLEM IDENTIFICATION 
    UPDATE_PROBLEM_IDENTIFICATION_DATA: 'UPDATE_PROBLEM_IDENTIFICATION_DATA'
};